module.exports = __webpack_public_path__ + "flatfair_all_blue.43bef5e7c08910cd0ff612e9da46a952.png";